<template>
<div class="vx-card">
    <div class="vx-card__header">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color h-30 p-2 justify-end" >
            <div class="w-full mt-1">

                <div class="mt-2">
                    <v-select readonly class="w-full" v-model="selected" :options="options" />

                </div>
            </div>
        </div>
    </div>
    <div class="vx-card__body">

        <GmapMap ref="mapRef" :center="center" map-type-id="satellite" :zoom="17" style="width: 100%; height: 1000px">
            <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :icon="m.icon" @mousewheel="toggleInfoWindow(m,index)" @click="toggleInfoWindow(m,index)"></GmapMarker>
            <!-- @mousewheel="toggleInfoWindow(m,index)" @click="toggleInfoWindow(m,index)"></GmapMarker> -->

            <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                <div v-html="infoContent"></div>
            </gmap-info-window>
        </GmapMap>
    </div>
</div>
</template>

<script>
import vSelect from "vue-select";
// import moduleDataList from "@/store/data-list/moduleDataList.js"
import l from "@/http/requests/serviceaideclients/index";
export default {

    data() {
        return {
            options: [{
                    id: "All",
                    label: "All"
                }, {
                    id: "M-BARDO",
                    label: "M-BARDO"
                },
                {
                    id: "M-CHARGUIA",
                    label: "M-CHARGUIA"
                },
                {
                    id: "M-MEDENINE",
                    label: "M-MEDENINE"
                }
            ],
            selected: {
                id: "All",
                label: "All"
            },
            listActiveLiv: [],
            currentLocation: null,
            polling: null,
            center: {
                lat: 36.8597308,
                lng: 10.2061247
            },
            markers: [],
            currentPlace: null,
            contentString: "hello world!",
            infoContent: "",
            infoWindowPos: {
                lat: 0,
                lng: 0
            },
            infoWinOpen: false,
            currentMidx: null,
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            }
        };
    },
    beforeMount() {},
    created() {
        this.initializeMap();
    },
    methods: {

        initializeMap() {
            navigator.geolocation.getCurrentPosition(position => {
                this.markers[0].position = {
                    lat: Number(position.coords.latitude),
                    lng: Number(position.coords.longitude)
                };

                // this.$store.dispatch("dataList/fetchLivreurPosActuelle")
                this.markers[1].position = {
                    lat: Number(this.$store.state.AppActiveLivreur.position.latitude),
                    lng: Number(this.$store.state.AppActiveLivreur.position.longtitude)
                };

                if (this.$store.state.AppActiveLivreur.id != "") {
                    this.center = {
                        lat: Number(position.coords.latitude),
                        lng: Number(position.coords.longitude)
                    };
                    // this.center = {
                    //     lat: Number(this.$store.state.AppActiveLivreur.position.latitude),
                    //     lng: Number(this.$store.state.AppActiveLivreur.position.longtitude)
                    // };
                } else
                    this.$store.subscribe(mutation => {
                        if (mutation.type === "UPDATE_LIVREUR_POS") {
                            this.center = {
                                lat: Number(position.coords.latitude),
                                lng: Number(position.coords.longitude)
                            };
                            // this.center = {
                            //     lat: Number(this.$store.state.AppActiveLivreur.position.latitude),
                            //     lng: Number(this.$store.state.AppActiveLivreur.position.longtitude)
                            // };
                        }
                    });
            });
        },
        toggleInfoWindow: function (marker, idx) {
            this.infoWindowPos = marker.position;
            this.infoContent = this.getInfoWindowContent(marker);

            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
                this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
                this.infoWinOpen = true;
                this.currentMidx = idx;
            }
        },
        getInfoWindowContent: function (marker) {
            return `<div class="card">

  <div class="card-content">
    <div class="media">
      <div class="media-content">
        <p class="title is-4">${marker.name}</p>
      </div>
    </div>
    <div class="content">
  </div>
</div>`;
        }
    },
    mounted() {

        this.polling = setInterval(() => {
            l.getAllPositions(this.selected.id).then(response => {
                    console.log(response)
                    this.markers = []

                    response.data.forEach(element => {
                        this.markers.push({
                            id: element.id,
                            name: element.fullName+' : '+ element.id,
                            description: element.fullName+' : '+element.id,
                            position: {
                                lat: Number(element.latitude),
                                lng: Number(element.longtitude)
                            },
                            icon: require("@/assets/images/portrait/small/image.gif")
                        })
                    });
                })
                .catch(() => {});

        }, 2000);
    },

    destroyed() {
        clearInterval(this.polling);
    },
    components: {
        vSelect,
    }
};
</script>

<style>
</style>
